import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

interface getInvoiceByIdInterface {
  id?: string
}
export const useGetInvoiceById = () => {
  const mutate = useMutation(({ id }: getInvoiceByIdInterface) => {
    return get(`/Invoice/${id}`)
  })
  return mutate
}
export default useGetInvoiceById
